import React from 'react';
import { ArrowLeft } from 'lucide-react';

export default function Datenschutz({ onClose }) {
  return (
    <div className="fixed inset-0 z-[60] bg-white overflow-y-auto" data-testid="datenschutz-page">
      {/* Header */}
      <div className="sticky top-0 bg-white border-b border-gray-100 py-4 px-4 sm:px-6 lg:px-8 z-10">
        <div className="max-w-3xl mx-auto flex items-center gap-4">
          <button
            onClick={onClose}
            data-testid="datenschutz-back-button"
            className="flex items-center gap-2 text-[#2D5A27] hover:text-[#10B981] font-['Manrope'] font-medium text-sm transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            Zurück zur Startseite
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <h1 className="font-['Outfit'] text-4xl sm:text-5xl font-bold text-[#1A3A22] tracking-tight mb-12">
          Datenschutzerklärung
        </h1>

        <div className="space-y-10 font-['Manrope'] text-gray-700 text-base leading-relaxed">
          {/* 1 */}
          <section>
            <h2 className="font-['Outfit'] text-2xl font-bold text-[#1A3A22] mb-4">
              1. Datenschutz auf einen Blick
            </h2>

            <h3 className="font-['Outfit'] text-lg font-semibold text-[#1A3A22] mb-2">Allgemeine Hinweise</h3>
            <p>
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten
              passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie
              persönlich identifiziert werden können.
            </p>

            <h3 className="font-['Outfit'] text-lg font-semibold text-[#1A3A22] mt-6 mb-2">Datenerfassung auf dieser Website</h3>
            <p className="font-semibold text-[#1A3A22]">Wer ist verantwortlich?</p>
            <p>Die Datenverarbeitung erfolgt durch den Websitebetreiber. Die Kontaktdaten können Sie dem Impressum entnehmen.</p>

            <p className="font-semibold text-[#1A3A22] mt-4">Wie erfassen wir Ihre Daten?</p>
            <p>Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen (z. B. über das Kontaktformular).</p>
            <p className="mt-2">Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Browser, Betriebssystem, Uhrzeit des Seitenaufrufs).</p>

            <p className="font-semibold text-[#1A3A22] mt-4">Wofür nutzen wir Ihre Daten?</p>
            <p>Ein Teil der Daten wird erhoben, um die fehlerfreie Bereitstellung der Website sicherzustellen. Andere Daten dienen der Bearbeitung Ihrer Anfrage.</p>

            <p className="font-semibold text-[#1A3A22] mt-4">Ihre Rechte</p>
            <p>Sie haben jederzeit das Recht auf:</p>
            <ul className="list-disc list-inside mt-2 space-y-1 ml-2">
              <li>Auskunft</li>
              <li>Berichtigung</li>
              <li>Löschung</li>
              <li>Einschränkung der Verarbeitung</li>
              <li>Datenübertragbarkeit</li>
            </ul>
            <p className="mt-2">Außerdem steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.</p>
          </section>

          {/* 2 */}
          <section>
            <h2 className="font-['Outfit'] text-2xl font-bold text-[#1A3A22] mb-4">
              2. Hosting
            </h2>
            <p>Diese Website wird extern gehostet.</p>
            <p className="mt-3">
              <strong className="text-[#1A3A22]">Anbieter:</strong><br />
              Vercel Inc.<br />
              440 N Barranca Ave #4133<br />
              Covina, CA 91723<br />
              USA
            </p>
            <p className="mt-3">Beim Aufruf der Website werden automatisch Daten durch Vercel verarbeitet (z. B. IP-Adresse, technische Zugriffsdaten).</p>
            <p className="mt-3">Die Verarbeitung erfolgt auf Grundlage von:</p>
            <ul className="list-disc list-inside mt-1 ml-2">
              <li>Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an sicherer und effizienter Bereitstellung)</li>
            </ul>
            <p className="mt-3">Eine Übertragung in die USA kann stattfinden. Diese erfolgt auf Grundlage geeigneter Garantien gemäß Art. 46 DSGVO (z. B. Standardvertragsklauseln).</p>
            <p className="mt-2">Es wurde ein Vertrag zur Auftragsverarbeitung abgeschlossen.</p>
          </section>

          {/* 3 */}
          <section>
            <h2 className="font-['Outfit'] text-2xl font-bold text-[#1A3A22] mb-4">
              3. Allgemeine Hinweise und Pflichtinformationen
            </h2>

            <h3 className="font-['Outfit'] text-lg font-semibold text-[#1A3A22] mb-2">Datenschutz</h3>
            <p>Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Vorschriften.</p>

            <h3 className="font-['Outfit'] text-lg font-semibold text-[#1A3A22] mt-6 mb-2">Verantwortliche Stelle</h3>
            <p>
              K.H. und B. Daniels Elektroinstallationen GmbH<br />
              Burbacher Straße 177<br />
              53129 Bonn
            </p>
            <p className="mt-2">
              Telefon: +49 228 23 46 44<br />
              E-Mail: info@daniels-gmbh.net
            </p>

            <h3 className="font-['Outfit'] text-lg font-semibold text-[#1A3A22] mt-6 mb-2">Datenschutzbeauftragter</h3>
            <p>
              Frank Daniels<br />
              Telefon: +49 228 23 46 44<br />
              E-Mail: info@daniels-gmbh.net
            </p>

            <h3 className="font-['Outfit'] text-lg font-semibold text-[#1A3A22] mt-6 mb-2">Widerruf Ihrer Einwilligung</h3>
            <p>Sie können eine erteilte Einwilligung jederzeit widerrufen.</p>

            <h3 className="font-['Outfit'] text-lg font-semibold text-[#1A3A22] mt-6 mb-2">Widerspruchsrecht (Art. 21 DSGVO)</h3>
            <p>Sie haben das Recht, jederzeit gegen die Verarbeitung Ihrer Daten Widerspruch einzulegen.</p>

            <h3 className="font-['Outfit'] text-lg font-semibold text-[#1A3A22] mt-6 mb-2">Beschwerderecht</h3>
            <p>Beschwerde bei einer Aufsichtsbehörde ist jederzeit möglich.</p>

            <h3 className="font-['Outfit'] text-lg font-semibold text-[#1A3A22] mt-6 mb-2">Datenübertragbarkeit</h3>
            <p>Sie haben das Recht, Daten in einem maschinenlesbaren Format zu erhalten.</p>

            <h3 className="font-['Outfit'] text-lg font-semibold text-[#1A3A22] mt-6 mb-2">SSL- bzw. TLS-Verschlüsselung</h3>
            <p>Diese Seite nutzt eine verschlüsselte Verbindung (HTTPS).</p>

            <h3 className="font-['Outfit'] text-lg font-semibold text-[#1A3A22] mt-6 mb-2">Auskunft, Löschung, Berichtigung</h3>
            <p>Sie können jederzeit Auskunft über Ihre Daten verlangen.</p>

            <h3 className="font-['Outfit'] text-lg font-semibold text-[#1A3A22] mt-6 mb-2">Einschränkung der Verarbeitung</h3>
            <p>Sie haben das Recht, die Verarbeitung Ihrer Daten einzuschränken.</p>
          </section>

          {/* 4 */}
          <section>
            <h2 className="font-['Outfit'] text-2xl font-bold text-[#1A3A22] mb-4">
              4. Datenerfassung auf dieser Website
            </h2>

            <h3 className="font-['Outfit'] text-lg font-semibold text-[#1A3A22] mb-2">Cookies</h3>
            <p>Unsere Website verwendet keine Cookies, die einer Einwilligung bedürfen.</p>
            <p className="mt-2">Es erfolgt:</p>
            <ul className="list-disc list-inside mt-1 ml-2 space-y-1">
              <li>kein Tracking</li>
              <li>keine Analyse</li>
              <li>keine Speicherung zu Marketingzwecken</li>
            </ul>
            <p className="mt-2">Ein Cookie-Banner wird dennoch eingesetzt, um Transparenz zu gewährleisten und zukünftige Erweiterungen rechtssicher abzubilden.</p>

            <h3 className="font-['Outfit'] text-lg font-semibold text-[#1A3A22] mt-6 mb-2">Server-Log-Dateien</h3>
            <p>Der Hosting-Anbieter erhebt automatisch:</p>
            <ul className="list-disc list-inside mt-1 ml-2 space-y-1">
              <li>Browsertyp</li>
              <li>Betriebssystem</li>
              <li>Referrer URL</li>
              <li>IP-Adresse</li>
              <li>Uhrzeit</li>
            </ul>
            <p className="mt-2">Diese Daten werden nicht mit anderen Daten zusammengeführt.</p>
            <p className="mt-1">Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO</p>

            <h3 className="font-['Outfit'] text-lg font-semibold text-[#1A3A22] mt-6 mb-2">Kontaktformular</h3>
            <p>Wenn Sie uns über das Kontaktformular kontaktieren, werden Ihre Daten verarbeitet.</p>
            <p className="mt-2">Zur technischen Abwicklung nutzen wir:</p>
            <ul className="list-disc list-inside mt-1 ml-2">
              <li>Resend Inc. (USA)</li>
            </ul>
            <p className="mt-2">Die eingegebenen Daten werden:</p>
            <ul className="list-disc list-inside mt-1 ml-2 space-y-1">
              <li>an Resend übermittelt</li>
              <li>per E-Mail an uns weitergeleitet</li>
            </ul>
            <p className="mt-2">Rechtsgrundlagen:</p>
            <ul className="list-disc list-inside mt-1 ml-2 space-y-1">
              <li>Art. 6 Abs. 1 lit. b DSGVO (Anfrage/Vertrag)</li>
              <li>Art. 6 Abs. 1 lit. f DSGVO (effiziente Bearbeitung)</li>
            </ul>
            <p className="mt-2">Die Übertragung in die USA erfolgt auf Basis geeigneter Garantien (Art. 46 DSGVO).</p>

            <h3 className="font-['Outfit'] text-lg font-semibold text-[#1A3A22] mt-6 mb-2">Kontakt per E-Mail / Telefon</h3>
            <p>Wenn Sie uns kontaktieren, werden Ihre Daten zur Bearbeitung gespeichert.</p>

            <h3 className="font-['Outfit'] text-lg font-semibold text-[#1A3A22] mt-6 mb-2">Verarbeitung von Kunden- und Vertragsdaten</h3>
            <p>Daten werden nur verarbeitet, soweit dies zur Vertragsabwicklung erforderlich ist.</p>
          </section>

          {/* 5 */}
          <section>
            <h2 className="font-['Outfit'] text-2xl font-bold text-[#1A3A22] mb-4">
              5. Inhalte und technische Einbindungen
            </h2>

            <h3 className="font-['Outfit'] text-lg font-semibold text-[#1A3A22] mb-2">Lokale Schriftarten</h3>
            <p>Die verwendeten Schriftarten sind lokal gespeichert.</p>
            <p>Es erfolgt keine Verbindung zu externen Servern.</p>

            <h3 className="font-['Outfit'] text-lg font-semibold text-[#1A3A22] mt-6 mb-2">Videos</h3>
            <p>Auf dieser Website werden Videos verwendet, die lokal gespeichert sind.</p>
            <p>Es erfolgt keine Datenübertragung an Dritte.</p>

            <h3 className="font-['Outfit'] text-lg font-semibold text-[#1A3A22] mt-6 mb-2">Externe Inhalte</h3>
            <p>Es werden keine externen Tracking- oder Analyse-Dienste eingesetzt.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
